module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-year-2021-8eb88c2da7a880aa3550070bab5c2d9f.svg";